import type { CameraApiResponse, Livestream } from "@src/services/api/cameras-api";
import { isLegacyAppCamera } from "./key-parser";

export type StreamingCapability = "jpeg" | "http-mp4";

export function getCameraStreamingCapability(camera: CameraApiResponse): StreamingCapability {
  return isLegacyAppCamera(camera) ? "jpeg" : "http-mp4";
}

export function supportsJpegStream(camera: CameraApiResponse): boolean {
  return getCameraStreamingCapability(camera) === "jpeg";
}

export function supportsMp4Stream(camera: CameraApiResponse): boolean {
  return getCameraStreamingCapability(camera) === "http-mp4";
}

const preferredFormats: Livestream["format"][] = ["mjpg", "mjpeg", "http-mjpeg", "http-mp4"];

/** The livestream the players play: MJPEG when the camera offers it, else the first. */
export function selectLivestream(livestreams?: Livestream[]): Livestream | undefined {
  if (!livestreams?.length) return undefined;
  for (const format of preferredFormats) {
    const match = livestreams.find((ls) => ls.format === format);
    if (match) return match;
  }
  return livestreams[0];
}

export function isMjpegFormat(format?: string | null): boolean {
  return format === "mjpeg" || format === "http-mjpeg" || format === "mjpg";
}
